module.exports = __webpack_public_path__ + "static/img/uy.79b02850.svg";